import(/* webpackMode: "eager", webpackExports: ["ArticleCard"] */ "/vercel/path0/components/ArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResearchCTA"] */ "/vercel/path0/components/cta/ResearchCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LatestResearch"] */ "/vercel/path0/components/home/LatestResearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ListenByGoal"] */ "/vercel/path0/components/home/ListenByGoal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
